export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: 'Home',
        games: 'Games',
        categories: 'Categories',
        about: 'About'
    },
    search: {
        placeholder: 'Search cat games...',
        suggestions: {
            game: 'Game',
            tag: 'Tag'
        }
    },

    // Hero Section
    hero: {
        title: 'Cat Games',
        description: 'Cat games on PlayCatGames let you play, care, and interact with virtual cats in all sorts of silly and clever ways. You might click or tap to cast toys across the screen, drag and drop outfits onto a character, or use quick reflexes to catch fish and chase rewards.',
        subtitle: 'Some cat games test timing as you jump, run, or climb, while others focus on simple actions like feeding, grooming, or tapping to score points. Every title is designed for instant fun in your browser. No installs. No downloads. Just meow!',
        buttons: {
            start: 'Start Playing',
            browse: 'Browse Categories'
        },
        stats: {
            games: 'Free Games',
            categories: 'Game Categories',
            free: 'Free Experience',
            available: 'Always Available'
        }
    },

    // Games Section
    games: {
        title: 'Popular Cat Games',
        subtitle: 'Discover the most popular free online cat games for players of all ages',
        filters: {
            all: 'All',
            dressUp: 'Dress Up',
            care: 'Care',
            puzzle: 'Puzzle',
            arcade: 'Arcade',
            simulation: 'Simulation'
        },
        loadMore: 'Load More Games',
        gameCategories: {
            arcade: 'Arcade',
            simulation: 'Simulation',
            care: 'Care',
            puzzle: 'Puzzle',
            dressUp: 'Dress Up'
        }
    },

    // Categories Section
    categories: {
        title: 'Game Categories',
        subtitle: 'Every cat game is built around activities players enjoy most: styling, caretaking, or dashing across silly courses',
        browse: 'Browse Category',
        featuredGames: 'Featured Games',
        gameCount: 'Games',
        types: {
            dressUp: {
                name: 'Cat Dress Up Games',
                description: 'Cat dress-up games let your creativity run wild. Mix outfits, add accessories, and unlock themed looks from fantasy sets to seasonal gear.'
            },
            simulation: {
                name: 'Cat Simulation & Roleplay',
                description: 'In simulator games, you step into the paws of a cat. Roam, explore, and live the curious life of a kitty.'
            },
            puzzle: {
                name: 'Cat Management & Puzzle Games',
                description: 'For strategy fans, cat puzzle and management games offer clever twists. Balance multiple cats, solve tricky stacking challenges.'
            },
            arcade: {
                name: 'Cat Arcade & Action Games',
                description: 'Fast-paced cat arcade games that test your reflexes and agility. Jump, run, catch, and enjoy thrilling gaming experiences.'
            }
        },
        additional: {
            title: 'Explore More Cat Game Types',
            description: 'Our cat game collection covers every mood and preference: fashion play, pet care, tricky puzzles, or silly arcade runs. Our browser-based cat games are free, safe, and ready to play within seconds.',
            motto: 'Just pick a game, tap start, and let the fun purr to life!'
        }
    },

    // About Section
    about: {
        title: 'About PlayCatGames',
        description: [
            'PlayCatGames is your ultimate destination for exploring the wonderful world of cat games. We have carefully curated a collection of free online cat-themed games suitable for players of all ages.',
            'From cute dress-up games to exciting arcade adventures, from warm care simulations to clever puzzle challenges, our game collection covers everything cat lovers could want. All games are carefully selected to ensure the best gaming experience.',
            'We believe games should be instant, fun, and easily accessible. That\'s why all our games can run directly in your browser without downloading or installing any software. Just click and start playing!'
        ],
        features: {
            free: '100% Free Games',
            mobile: 'Mobile Friendly',
            instant: 'Instant Play',
            safe: 'Safe & Secure'
        },
        cards: {
            gamesCount: '50+ Games',
            gamesUpdate: 'Regular Updates',
            rating: '4.8/5 Rating',
            recommended: 'Player Recommended'
        },
        faq: {
            title: 'Frequently Asked Questions',
            questions: {
                free: {
                    q: 'Are these games really free?',
                    a: 'Yes! All our cat games are completely free. You don\'t need to pay anything to enjoy all game content.'
                },
                download: {
                    q: 'Do I need to download any software?',
                    a: 'No! All games can run directly in your browser. Just click on a game to start playing, no downloads or installations required.'
                },
                age: {
                    q: 'What age group are these games suitable for?',
                    a: 'Our cat games are suitable for players of all ages. From simple dress-up games to challenging puzzle games, everyone can find games that suit them.'
                },
                mobile: {
                    q: 'Do the games support mobile devices?',
                    a: 'Yes! All our games are optimized to run perfectly on PCs, tablets, and phones. You can enjoy gaming fun anytime, anywhere.'
                },
                updates: {
                    q: 'Will you add new games?',
                    a: 'Absolutely! We regularly update our game library and add new interesting cat games. Please come back often to check out the latest game content.'
                }
            }
        }
    },

    // Footer
    footer: {
        description: 'Your free online cat games collection destination. Discover, play, and enjoy dozens of exciting cat-themed games.',
        quickLinks: 'Quick Links',
        gameCategories: 'Game Categories',
        support: 'Support',
        links: {
            popularGames: 'Popular Games',
            latestGames: 'Latest Games',
            recommendedGames: 'Recommended Games',
            faq: 'FAQ',
            contact: 'Contact Us',
            feedback: 'Feedback',
            privacy: 'Privacy Policy',
            terms: 'Terms of Service',
            cookies: 'Cookie Policy',
            sitemap: 'Sitemap'
        },
        copyright: 'All rights reserved.',
        disclaimer: 'All game content is sourced from the internet for entertainment and educational purposes only. Please contact us if there are any copyright issues.',
        backToTop: 'Back to Top',
        friendlyLinks: 'Friendly Links'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: 'Help the kitten catch flying birds and show your reaction speed',
            catPizza: 'Run a cat pizza shop and make delicious pizzas for customers',
            funnyKittyCare: 'Take care of cute kittens, feed, bathe and play',
            catsDrop: 'Cat stacking game that tests your balance and strategy skills',
            catpad: 'Cute cat platform jumping game',
            funnyKittyDressup: 'Dress up cute kittens with various clothes and accessories',
            kittyCats: 'Casual game to interact with multiple cute cats',
            dualCat: 'Challenge game controlling two cats simultaneously',
            funnyKittyHaircut: 'Beauty game designing fashionable hairstyles for kittens',
            catCoffeeShop: 'Run a cat coffee shop and make delicious drinks'
        },
        categories: {
            puzzle: 'Puzzle',
            simulation: 'Simulation',
            casual: 'Casual',
            action: 'Action',
            adventure: 'Adventure',
            strategy: 'Strategy',
            sports: 'Sports',
            racing: 'Racing',
            dressup: 'Dress Up',
            care: 'Care'
        },
        tags: {
            cute: 'Cute',
            anime: 'Anime',
            dark: 'Dark',
            funny: 'Funny',
            educational: 'Educational',
            multiplayer: 'Multiplayer',
            relaxing: 'Relaxing',
            challenging: 'Challenging',
            colorful: 'Colorful',
            simple: 'Simple',
            complex: 'Complex',
            family: 'Family Friendly',
            kids: 'Kids',
            adult: 'Adult'
        }
    },

    // Common
    common: {
        loading: 'Loading...',
        error: 'Something went wrong',
        retry: 'Retry',
        play: 'Play Game',
        language: 'Language',
        backToHome: 'Back to Home'
    },

    // Game Play Page
    gamePage: {
        plays: 'plays',
        share: 'Share',
        enterFullscreen: 'Fullscreen',
        exitFullscreen: 'Exit Fullscreen',
        loadingGame: 'Loading game...',
        reload: 'Reload',
        linkCopied: 'Link copied to clipboard',
        notFound: {
            title: 'Game Not Found',
            message: 'Sorry, we couldn\'t find this game. It may have been removed or the link is incorrect.'
        },
        loadError: {
            title: 'Failed to Load Game',
            message: 'Unable to load game content. Please check your connection or try again later.'
        }
    },

    // Legal Pages
    legal: {
        privacy: {
            title: 'Privacy Policy',
            lastUpdated: 'Last Updated',
            sections: {
                overview: {
                    title: 'Overview',
                    content: 'PlayCatGames ("we", "our", or "this website") is committed to protecting your privacy. This privacy policy explains how we collect, use, and protect the information you provide when using our website.'
                },
                dataCollection: {
                    title: 'Information Collection',
                    intro: 'We may collect the following types of information:',
                    items: [
                        'Automatically collected information: including your IP address, browser type, operating system, access time, and referring pages',
                        'Cookies and similar technologies: used to improve your browsing experience and analyze website usage',
                        'Language preferences: used to provide personalized multilingual experience',
                        'Game usage data: including game preferences and usage statistics (anonymized)'
                    ]
                },
                dataUsage: {
                    title: 'Information Usage',
                    intro: 'We use the collected information for:',
                    items: [
                        'Providing and maintaining our services',
                        'Improving user experience and website functionality',
                        'Analyzing website usage patterns',
                        'Providing technical support',
                        'Complying with legal obligations'
                    ]
                },
                cookies: {
                    title: 'Cookies',
                    content: 'We use cookies to enhance your browsing experience. Cookies are small text files stored on your device that help us remember your preference settings. You can control cookie usage through your browser settings.'
                },
                thirdParty: {
                    title: 'Third-Party Services',
                    content: 'Our website may contain links to third-party websites. We are not responsible for the privacy practices of these websites. We recommend reviewing the privacy policy of each website you visit.'
                },
                security: {
                    title: 'Data Security',
                    content: 'We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure. However, please note that no method of Internet transmission is 100% secure.'
                },
                children: {
                    title: 'Children\'s Privacy',
                    content: 'Our services are designed for users of all ages. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and discover that your child has provided us with personal information, please contact us.'
                },
                changes: {
                    title: 'Policy Updates',
                    content: 'We may update this privacy policy from time to time. Any changes will be posted on this page and the "Last Updated" date will be updated. We recommend reviewing this policy regularly.'
                },
                contact: {
                    title: 'Contact Us',
                    content: 'If you have any questions or concerns about this privacy policy, please contact us:',
                    email: 'Email'
                }
            }
        },
        terms: {
            title: 'Terms of Service',
            lastUpdated: 'Last Updated',
            sections: {
                acceptance: {
                    title: 'Acceptance of Terms',
                    content: 'By accessing and using the PlayCatGames website, you agree to comply with these terms of service. If you do not agree to these terms, please do not use our services.'
                },
                services: {
                    title: 'Service Description',
                    content: 'PlayCatGames provides free online cat-themed games. Our services include game content, website functionality, and related services, all provided through our website.'
                },
                userConduct: {
                    title: 'User Conduct',
                    intro: 'When using our services, you agree not to:',
                    items: [
                        'Engage in any illegal or harmful activities',
                        'Interfere with or disrupt the normal operation of the website',
                        'Attempt to gain unauthorized access',
                        'Upload or transmit harmful content',
                        'Violate the rights or privacy of others'
                    ]
                },
                intellectualProperty: {
                    title: 'Intellectual Property',
                    content: 'All content on the website, including but not limited to text, images, games, and designs, is protected by copyright and other intellectual property laws. You may not copy, distribute, or modify any content without explicit permission.'
                },
                disclaimer: {
                    title: 'Disclaimer',
                    content: 'Our services are provided "as is" without any express or implied warranties. We do not guarantee the accuracy, reliability, or availability of the services.'
                },
                liability: {
                    title: 'Limitation of Liability',
                    content: 'To the maximum extent permitted by law, PlayCatGames shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of our services.'
                },
                modifications: {
                    title: 'Terms Modification',
                    content: 'We reserve the right to modify these terms of service at any time. Modified terms will be posted on the website and take effect immediately. Continued use of services indicates your acceptance of the modified terms.'
                },
                termination: {
                    title: 'Service Termination',
                    content: 'We reserve the right to suspend or terminate your access to the services at any time, for any reason, without prior notice.'
                },
                governing: {
                    title: 'Governing Law',
                    content: 'These terms of service are governed by the laws of the People\'s Republic of China. Any disputes should be resolved through friendly consultation, and if consultation fails, submitted to arbitration.'
                },
                contact: {
                    title: 'Contact Us',
                    content: 'If you have any questions about these terms of service, please contact us:',
                    email: 'Email'
                }
            }
        },
        cookies: {
            title: 'Cookie Policy',
            lastUpdated: 'Last Updated',
            sections: {
                what: {
                    title: 'What are Cookies',
                    content: 'Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work or work more efficiently, as well as to provide information to website owners.'
                },
                usage: {
                    title: 'How We Use Cookies',
                    intro: 'We use cookies to:',
                    items: [
                        'Remember your language preference settings',
                        'Analyze website traffic and usage patterns',
                        'Improve website performance and user experience',
                        'Provide personalized content',
                        'Ensure website security'
                    ]
                },
                types: {
                    title: 'Types of Cookies',
                    essential: {
                        title: 'Essential Cookies',
                        content: 'These cookies are necessary for the website to function and cannot be disabled. They are usually set only in response to your actions, such as setting privacy preferences, logging in, or filling out forms.'
                    },
                    functional: {
                        title: 'Functional Cookies',
                        content: 'These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.'
                    },
                    analytics: {
                        title: 'Analytics Cookies',
                        content: 'These cookies help us understand how visitors interact with the website. They provide information about the number of visitors, the time they spend on the website, and the pages they visit.'
                    }
                },
                control: {
                    title: 'Controlling Cookies',
                    content: 'You can control and delete cookies through your browser settings. However, please note that disabling certain cookies may affect the website\'s functionality and your user experience.'
                },
                thirdParty: {
                    title: 'Third-Party Cookies',
                    content: 'Our website may contain cookies from third-party services, such as analytics tools or social media plugins. These third parties have their own privacy policies, and we recommend reviewing them.'
                },
                updates: {
                    title: 'Policy Updates',
                    content: 'We may update this Cookie Policy from time to time. Any changes will be posted on this page and the "Last Updated" date will be updated.'
                },
                contact: {
                    title: 'Contact Us',
                    content: 'If you have any questions about our use of cookies, please contact us:',
                    email: 'Email'
                }
            }
        }
    },

    // Sitemap
    sitemap: {
        title: 'Sitemap',
        description: 'Find all pages and content on the PlayCatGames website',
        sections: {
            main: {
                title: 'Main Pages',
                home: 'Home',
                games: 'Games',
                categories: 'Categories',
                about: 'About Us'
            },
            categories: {
                title: 'Game Categories',
                dressUp: 'Dress Up Games',
                care: 'Care Games',
                puzzle: 'Puzzle Games',
                arcade: 'Arcade Games',
                simulation: 'Simulation Games'
            },
            games: {
                title: 'Popular Games'
            },
            support: {
                title: 'Support',
                faq: 'FAQ',
                contact: 'Contact Us',
                feedback: 'Feedback'
            },
            legal: {
                title: 'Legal Pages',
                privacy: 'Privacy Policy',
                terms: 'Terms of Service',
                cookies: 'Cookie Policy'
            },
            languages: {
                title: 'Language Support'
            }
        },
        info: {
            title: 'About This Website',
            description: 'PlayCatGames offers a rich collection of free online cat games, supporting multiple languages and providing the best gaming experience for players worldwide. All games are carefully selected to ensure they are safe, fun, and suitable for all ages.'
        }
    }
}